import React from 'react';

const RentalInputsContext = React.createContext(null);

export default RentalInputsContext;